import styles from './SingleSignOn.module.scss';
import { FunctionComponent, useEffect, useRef } from 'react';
import { BrowserStorage, CookieKeys, Cookies, ICookies, ISessionStorage } from '../../core/services/module';
import { QueryParams, Routes } from '../../core/enums/module';
import { getQueryParameters } from '../../utilities/getQueryParameter';
import { getNextRoute } from '../../utilities/getNextRoute';
import { SessionStorageKeys } from '../../core/services/browserStorage/keys/sessionStorageKeys';
import { FeatureFlagService } from '@delta-defense/feature-flag-service';
import { IFeatureFlagRepository } from '@delta-defense/feature-flag-service/service/iFeatureFlagRepository';
import { elegantEnabled } from '../../utilities/elegantEnabled';
import { setSSOFormAction } from './utils/setSSOFormAction';

type Props = {
	cookies?: ICookies;
	mainWindow?: Window;
	mainSessionStorage?: ISessionStorage;
	featureFlags?: IFeatureFlagRepository;
};

const SingleSignOn: FunctionComponent<Props> = ({
	cookies = Cookies.Instance(),
	mainWindow = window,
	mainSessionStorage = BrowserStorage.SessionInstance(),
	featureFlags = FeatureFlagService.Instance()
}) => {
	const subscription = mainSessionStorage ? mainSessionStorage.getItem(SessionStorageKeys.PurchasedSubscription) : null;
	const ssoForm = useRef<HTMLFormElement>(null);
	const redirectUrlInput = useRef<HTMLInputElement>(null);
	const submitButton = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const urlParams = getQueryParameters();
		const subscriptionId = subscription?.id || urlParams.get(QueryParams.SubscriptionId);

		if (subscriptionId) {
			if (redirectUrlInput.current) {
				urlParams.set(QueryParams.Type, 'confirmation');
				urlParams.set(QueryParams.SubscriptionId, subscriptionId);
				const route = getNextRoute(elegantEnabled(location.href) ? Routes.Elegant : Routes.SignupSummary);
				redirectUrlInput.current.value = route.startsWith('/') ? `${mainWindow.location.origin}${route}?${urlParams.toString()}` : route;
			}
		}

		setSSOFormAction(ssoForm);
		cookies.set(CookieKeys.SSO, 'true');
		submitButton.current?.click();
	}, []);

	return (
		<form id="ssoForm" ref={ssoForm} className={styles.sso_form} method="POST">
			<input id="action_input" type="text" name="action" value="login" readOnly />
			<input id="redirect_url_input" ref={redirectUrlInput} type="text" name="redirectTo" value="" readOnly />
			<input id="uscca_access_input" type="text" name="uscca_access" value={cookies.get(CookieKeys.AccessToken)} readOnly />
			<input id="uscca_lead_fields_input" type="text" name="uscca_lead_fields" value={cookies.get(CookieKeys.Leads)} readOnly />
			<input id="ssoFormSubmit" ref={submitButton} type="submit" value="Submit" />
		</form>
	);
};

export default SingleSignOn;
